/**
 * Generated by orval v7.7.0 🍺
 * Do not edit manually.
 * GTO Wizard API v4
 * API documentation for GTO Wizard frontend API
 * OpenAPI spec version: 4
 */
import { useQuery } from '@tanstack/vue-query'
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query'

import { unref } from 'vue'
import type { MaybeRef } from 'vue'

import type {
  GetUserCreditTransactionsListParams,
  PagedUserCreditTransactionResponseSchema,
  UserCreditBalanceResponseSchema,
} from '../models'

import getUserCreditTransactionsBalanceMutator from '../../../client'
import getUserCreditTransactionsListMutator from '../../../client'

type AwaitedInput<T> = PromiseLike<T> | T

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never

/**
 * @summary Get User Credit Transactions Balance
 */
export const getUserCreditTransactionsBalance = (signal?: AbortSignal) => {
  return getUserCreditTransactionsBalanceMutator<UserCreditBalanceResponseSchema>({
    url: `/v4/credit-transactions/balance/`,
    method: 'GET',
    signal,
  })
}

export const getGetUserCreditTransactionsBalanceQueryKey = () => {
  return ['v4', 'credit-transactions', 'balance'] as const
}

export const getGetUserCreditTransactionsBalanceQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserCreditTransactionsBalance>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getUserCreditTransactionsBalance>>,
    TError,
    TData
  >
}) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = getGetUserCreditTransactionsBalanceQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserCreditTransactionsBalance>>> = ({
    signal,
  }) => getUserCreditTransactionsBalance(signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserCreditTransactionsBalance>>,
    TError,
    TData
  >
}

export type GetUserCreditTransactionsBalanceQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUserCreditTransactionsBalance>>
>
export type GetUserCreditTransactionsBalanceQueryError = unknown

/**
 * @summary Get User Credit Transactions Balance
 */

export function useGetUserCreditTransactionsBalance<
  TData = Awaited<ReturnType<typeof getUserCreditTransactionsBalance>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getUserCreditTransactionsBalance>>,
    TError,
    TData
  >
}): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetUserCreditTransactionsBalanceQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey }

  query.queryKey = unref(queryOptions).queryKey as QueryKey

  return query
}

/**
 * @summary Get User Credit Transactions List
 */
export const getUserCreditTransactionsList = (
  params?: MaybeRef<GetUserCreditTransactionsListParams>,
  signal?: AbortSignal,
) => {
  params = unref(params)

  return getUserCreditTransactionsListMutator<PagedUserCreditTransactionResponseSchema>({
    url: `/v4/credit-transactions/list/`,
    method: 'GET',
    params: unref(params),
    signal,
  })
}

export const getGetUserCreditTransactionsListQueryKey = (
  params?: MaybeRef<GetUserCreditTransactionsListParams>,
) => {
  return ['v4', 'credit-transactions', 'list', ...(params ? [params] : [])] as const
}

export const getGetUserCreditTransactionsListQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserCreditTransactionsList>>,
  TError = unknown,
>(
  params?: MaybeRef<GetUserCreditTransactionsListParams>,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getUserCreditTransactionsList>>,
      TError,
      TData
    >
  },
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = getGetUserCreditTransactionsListQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserCreditTransactionsList>>> = ({
    signal,
  }) => getUserCreditTransactionsList(params, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserCreditTransactionsList>>,
    TError,
    TData
  >
}

export type GetUserCreditTransactionsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUserCreditTransactionsList>>
>
export type GetUserCreditTransactionsListQueryError = unknown

/**
 * @summary Get User Credit Transactions List
 */

export function useGetUserCreditTransactionsList<
  TData = Awaited<ReturnType<typeof getUserCreditTransactionsList>>,
  TError = unknown,
>(
  params?: MaybeRef<GetUserCreditTransactionsListParams>,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getUserCreditTransactionsList>>,
      TError,
      TData
    >
  },
): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetUserCreditTransactionsListQueryOptions(params, options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey }

  query.queryKey = unref(queryOptions).queryKey as QueryKey

  return query
}
